import React from 'react';
import cn from 'classnames';
import IconCalendar from '@creditflowresearch/uilib/Icon/IconCalendar';
import IconCancelCircle from '@creditflowresearch/uilib/Icon/IconCancelCircle';
import styles from './datePicker.module.scss';
import IconButton from '@creditflowresearch/uilib/IconButton';

interface IDatePickerInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  ref?: React.Ref<HTMLInputElement>,
  rowRef?: React.Ref<HTMLDivElement>,
  dataTest: string,
  inputClassName?: string,
  inputDataTest?: string,
  hasError?: boolean,
  isDisabled?: boolean,
  isOpen?: boolean,
  showClearButton?: boolean,
  onRowClick?: (event: React.MouseEvent) => void,
  onClear?: (event: React.MouseEvent) => void,
}

const DatePickerInput = ({
  ref,
  rowRef,
  dataTest,
  inputClassName,
  inputDataTest,
  hasError,
  isDisabled,
  isOpen,
  showClearButton,
  onRowClick,
  onClear,
  className,
  ...inputProps
}: IDatePickerInputProps) => (
  <div
    ref={ rowRef }
    className={ cn(styles.inputRow, inputClassName, {
      [styles.inputRowError]: hasError,
      [styles.inputRowDisabled]: isDisabled,
      [styles.inputRowOpen]: isOpen,
    }) }
    data-test={ inputDataTest ?? `${ dataTest }Input` }
    onClick={ onRowClick }
  >
    <input
      ref={ ref }
      { ...inputProps }
      data-test={ inputProps.name }
      className={ cn(styles.input, className) }
    />
    <span className={ cn(styles.calendarIcon, { [styles.calendarIconHidable]: showClearButton }) }>
      <IconCalendar />
    </span>
    { showClearButton && (
      <IconButton
        icon={ <IconCancelCircle data-test="iconClose" /> }
        className={ styles.clearButton }
        onMouseDown={ (e) => e.preventDefault() }
        onClick={ onClear }
        ariaLabel="Clear date"
        dataTest={ `${ dataTest }Clear` }
      />
    ) }
  </div>
);

export default DatePickerInput;
